<template>
  <admin-layout :breadcrumb="false">

    <template slot="list">
      <v-container grid-list-md>
        <header-for-list-component
            v-if="!typology.selectable"
            sectionName="Tipologias"
            :items="typology.typologies"
            :totalItems="typology.typologies.length || 1"
            :totalPages="1"
            :pageNumber="1"
            @loadPage="loadPage($event)"
        />
        <div>
          <v-btn :to="backButton()">
            <v-icon>mdi-arrow-left</v-icon> Voltar
          </v-btn>
        </div>

        <div row wrap justify-center
             v-if="typology.selectable">
          <v-tabs
            v-model="active"
            color="green darken-2"
            dark
            slider-color="white">
            <v-tab ripple>
              Tipologia
            </v-tab>
            <v-tab ripple>
              Taxa
            </v-tab>
            <v-tab ripple>
              Estudo Ambiental
            </v-tab>
            <v-tab ripple>
              Checklists
            </v-tab>

            <v-tab ripple>
              Parâmetros Técnicos
            </v-tab>

            <!--Tipologia-->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-list>
                    <h3>{{typology.code}} - {{typology.name}}</h3>
                    <span v-if="typology.degrading_potential">
                      Potencial Degradador: {{typology.degrading_potential.name}}
                    </span>
                    <span class="d-block">
                      Porte (Taxa): {{typology.typology_size_for_tax_name}}
                    </span>
                    <span class="d-block">
                      Potencial Degradador (Taxa): {{typology.degrading_potential_for_tax_name}}
                    </span>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!--Tipologia-->
            <!--Taxa-->
            <v-tab-item>
              <tax-component :typology="typology"></tax-component>
            </v-tab-item>
            <!--Taxa-->
            <!--Estudo Ambiental-->
            <v-tab-item>
              <enviromental-study :typology="typology"></enviromental-study>
            </v-tab-item>
            <!--Estudo Ambiental-->
            <!--Checklists-->
            <v-tab-item>
              <checklist-component :typology="typology"></checklist-component>
            </v-tab-item>
            <!--Checklists-->
            <!--Parâmetros Técnicos-->
            <v-tab-item>
              <technical-parameters-component :typology="typology" />
            </v-tab-item>
            <!--Parâmetros Técnicos-->
          </v-tabs>
        </div>
        <div v-else>
          <!-- Sub-tipologias - quando a Typology não é selecionável-->
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card flat>
                  <v-card-text>
                    <v-list>
                      <h3>{{typology.code}} - {{typology.name}}
                        <create-or-update-typology :typology-id="typologyId"
                                         mode="create"
                                         :dialog="true"
                                         v-on:createTypology="createTypology($event)">
                        </create-or-update-typology>
                      </h3>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="headers"
                  :items="typology.typologies"
                  hide-actions
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id }}</td>
                    <td class="text-xs-center">{{ props.item.code }}</td>
                    <td class="text-xs-center">{{ props.item.name }}</td>
                    <td class="text-xs-center">
                      <v-layout row>
                        <v-btn flat icon @click="showTypology(props.item.id)">
                          <v-icon small>mdi-eye</v-icon>
                        </v-btn>
                        <create-or-update-typology :typology-id="typologyId"
                                         :dialog="true"
                                         :typology="props.item"
                                         mode="edit"
                                         v-on:createTypology="updateTypology($event)">
                        </create-or-update-typology>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>

        </div>

        <!-- Start Dialog Edit Typology-->
        <!--<v-dialog v-model="dialogEditTypologySize" width="500">-->
          <!--<v-card>-->
            <!--<v-card-title class="headline grey lighten-2" primary-title>-->
              <!--Editar Tipologia-->
            <!--</v-card-title>-->

            <!--<v-card-text>-->

              <!--<v-form v-model="valid">-->
                <!--<v-text-field-->
                  <!--v-model="editedItem.min"-->
                  <!--label="Valor Mínimo"-->
                  <!--required></v-text-field>-->
                <!--<v-text-field-->
                  <!--v-model="editedItem.max"-->
                  <!--label="Valor Máximo"-->
                  <!--required></v-text-field>-->
                <!--<v-select-->
                  <!--v-model="editedItem.zone_id"-->
                  <!--:hint="'Selecione uma Zona de Enquadramento'"-->
                  <!--:items="zones"-->
                  <!--item-text="name"-->
                  <!--item-value="id"-->
                  <!--single-line-->
                  <!--label="Zona de Enquadramento"></v-select>-->
                <!--<v-select-->
                  <!--v-model="editedItem.enviromental_study_type_id"-->
                  <!--:hint="'Selecione um Tipo de Estudo Ambiental'"-->
                  <!--:items="enviromentalStudyTypes"-->
                  <!--item-text="name"-->
                  <!--item-value="id"-->
                  <!--single-line-->
                  <!--label="Tipo de Estudo Ambiental"></v-select>-->
              <!--</v-form>-->

            <!--</v-card-text>-->

            <!--<v-divider></v-divider>-->

            <!--<v-card-actions>-->
              <!--<v-spacer></v-spacer>-->
              <!--<v-btn color="primary" flat @click="updateTypologySize">Salvar Porte-->
              <!--</v-btn>-->
            <!--</v-card-actions>-->
          <!--</v-card>-->
        <!--</v-dialog>-->
        <!--End Dialog Edit Typology-->

      </v-container>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout'
import NavigationBreadcrumb from '@/components/base/NavigationBreadcrumb';

import TaxComponent from '@/components/configurations/typology/show/tax/TaxComponent';
import EnviromentalStudy from '@/components/configurations/typology/show/enviromental_study/EnviromentalStudy';
import ChecklistComponent from '@/components/configurations/typology/show/checklist/ChecklistComponent';
import TechnicalParametersComponent from '@/components/configurations/typology/show/technical_parameter/TechnicalParametersComponent';

import CreateOrUpdateTypology from '@/components/configurations/typology/create_typology/CreateOrUpdateTypology';

import TypologyService from '@/services/applications/configurations/TypologyService';
import ZoneService from '@/services/applications/configurations/ZoneService';

import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';

export default {
  name: 'TypologiesShow',
  components: {
    AdminLayout,
    NavigationBreadcrumb,

    TaxComponent,
    EnviromentalStudy,
    ChecklistComponent,
    TechnicalParametersComponent,

    CreateOrUpdateTypology,
    HeaderForListComponent,
  },
  watch: {
    $route() {
      this.typologyId = this.$route.params.id;
      this.loadTypology();
    },
  },
  mounted() {
    ZoneService
      .fetchZones()
      .then((response) => {
        this.zones = response.data;
      });

    this.loadTypology();
  },
  data() {
    return {
      active: null,
      typology: { typologies: [] },
      typologyId: this.$route.params.id,
      zones: [],
      headers: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Código', value: 'code', align: 'center' },
        { text: 'Nome', value: 'name', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' }],
    };
  },
  methods: {
    showTypology(id) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push({ name: 'TypologyShow', params: { id } });
    },
    createTypology(typology) {
      this.typology.typologies.push(typology);
    },
    updateTypology(typology) {
      Object.assign(
        this.typology.typologies.find(element => element.id == typology.id),
        typology
      );
    },
    backButton() {
      if (this.typology.typology_id == undefined) {
        return { name: 'TypologyList' };
      }
      return { name: 'TypologyShow', params: { id: this.typology.typology_id } };
    },
    loadTypology() {
      TypologyService
        .fetchTypology(this.$route.params.id)
        .then((response) => {
          this.typology = response.data;
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
